import _ from 'lodash'
import scrollMonitor from 'scrollmonitor'
// todo: remove scroll monitor
import { replaceSpecialCharacters } from '@/common/utils/common'
import { ON_DISPLAY_BAND } from '@/common/resources/const'

// const LANDSCAPE_CELL_TEXT_BOX_WIDTH = 220
// const LANDSCAPE_CELL_TEXT_BOX_HEIGHT = 26
// const PORTRAIT_CELL_TEXT_BOX_WIDTH = 220
// const PORTRAIT_CELL_TEXT_BOX_HEIGHT = 26
// const CIRCLE_CELL_TEXT_BOX_WIDTH = 140
// const CIRCLE_CELL_TEXT_BOX_HEIGHT = 26

// TODO: 하늘색 컬러값 변경
export const convertSpecialSymbols = (titleText) => {
  let text = titleText
  if (text.indexOf('@0@') > -1) {
    text = _.replace(text, '@0@', '<strong style="font-weight: 700;">')
    text = _.replace(text, '@^0@', '</strong>')
  }
  if (text.indexOf('@1@') > -1) {
    text = _.replace(text, '@1@', '<span style="color: #3887ff;">')
    text = _.replace(text, '@^1@', '</span>')
  }
  if (text.indexOf('@2@') > -1) {
    text = _.replace(
      text,
      '@2@',
      '<strong style="color: #3887ff; font-weight: 700;">',
    )
    text = _.replace(text, '@^2@', '</strong>')
  }
  if (text.indexOf('@3@') > -1) {
    text = _.replace(text, '@3@', '<span style="color: #00bbec;">')
    text = _.replace(text, '@^3@', '</span>')
  }
  if (text.indexOf('@4@') > -1) {
    text = _.replace(
      text,
      '@4@',
      '<strong style="color: #00bbec; font-weight: 700;">',
    )
    text = _.replace(text, '@^4@', '</strong>')
  }
  if (text.indexOf('@5@') > -1) {
    text = _.replace(text, '@5@', '<del>')
    text = _.replace(text, '@^5@', '</del>')
  }
  return text
}
export const bandTitle = {
  bind: (el) => {
    el.innerHTML = convertSpecialSymbols(el.innerHTML)
  },
  update: (el) => {
    el.innerHTML = convertSpecialSymbols(el.innerHTML)
  },
  componentUpdated: (el) => {
    el.innerHTML = convertSpecialSymbols(el.innerHTML)
  },
}
export const changeColorSearchWord = (text, searchWord) => {
  if (searchWord.length > 0) {
    return text
      .split(searchWord)
      .join(`<span class="col-vari-blue">${searchWord}</span>`)
  } else {
    return text
  }
}

export const titleList = {
  bind: (el, binding) => {
    const {
      titleList = [],
      searchWord = '',
      cellType,
      callback,
    } = binding.value
    el.innerHTML = titleList
      .map((title, idx) => {
        let text = _.get(title, 'text', '')
        let maxLine = Number(_.get(title, 'maxline', '1'))
        if (text === '') {
          if (idx === 1 && cellType === 'landscape') {
            return `<div class="cell-title"> <span class="title${idx + 1} line1">&nbsp;</span> </div>`
          } else {
            return null
          }
        }
        if (typeof searchWord === 'string') {
          text = changeColorSearchWord(
            text,
            replaceSpecialCharacters(searchWord),
          )
        }
        if (text.indexOf('$O$') > -1) {
          text = text.replace(/\$O\$/gi, '<span class="icon-dotted"></span>')
        }
        if (title.text.indexOf('<br') > -1) {
          maxLine = 2
        }
        let titleClass = `title${idx + 1} line${maxLine}`
        return `<div class="cell-title"><span class="${titleClass}">${convertSpecialSymbols(text)}</span></div>`
      })
      .filter((title) => {
        return title !== null
      })
      .join('')
    callback && callback(el)
  },
}

const getBottomTagListEl = (tag) => {
  let className = ''
  let tagText = ''
  switch (tag) {
    case 'free':
      className = 'tag-free'
      tagText = '무료'
      break
    case 'dubbing':
      className = 'tag-dubbing'
      tagText = '더빙'
      break
    case 'subtitle':
      className = 'tag-subtitle'
      tagText = '자막'
      break
    case 'disablepc':
      className = 'tag-disablepc'
      tagText = 'PC불가'
      break
    case 'won':
      className = 'tag-won'
      tagText = '개별구매'
      break
    case 'playy':
      className = 'tag-playy'
      tagText = 'PLAYY'
      break
    default:
      className = ''
      tagText = ''
  }
  return `<span class="${className}">${tagText}</span>`
}

const getTopTagListEl = (tag) => {
  let className = 'badge artwork'
  let tagText = ''
  switch (tag) {
    case 'won':
      tagText = '개별구매'
      break
    case 'event':
      tagText = '이벤트'
      break
    case 'free':
      tagText = '무료'
      break
    case 'discount':
      tagText = '할인'
      break
    case 'quickvod':
      className += ' quick-vod'
      tagText = 'Quick VOD'
      break
    case 'recommend':
      tagText = '추천'
      break
    case 'reserve':
      className = 'tag-reserve'
      tagText = '예약구매'
      break
    case 'new':
      tagText = 'NEW'
      break
    default:
      className = ''
      tagText = ''
  }
  if (className === '' && tagText === '') {
    return ''
  } else {
    return `<li><span class="${className}">${tagText}</span></li>`
  }
}
const getBrandTagListEl = (tag, index) => {
  let className = ''
  switch (tag) {
    case 'original':
    case 'exclusive':
    case 'firstrun':
      className = 'wavve'
      break
    default:
      className = tag
  }
  return tag !== '' && index === 0
    ? `<span class="brand ${className.toLowerCase()}">${tag}</span></em>`
    : ''
}
const getBottomLabelListEl = (tag) => {
  let labelText = ''
  switch (tag) {
    case 'new_movie':
      labelText = '신작 업데이트'
      break
    case 'new_vod':
      labelText = '신규 시리즈'
      break
    default:
      labelText = ''
  }
  return tag === ''
    ? ''
    : `<span class="badge artwork">${labelText}</span></em>`
}
export const bottomTagList = {
  inserted: (el, binding) => {
    const { value } = binding
    if (value === '') return
    el.innerHTML = value.map(getBottomTagListEl).join('')
  },
}

export const topTagList = {
  inserted: (el, binding) => {
    const { value } = binding
    let res = ''
    if (Array.isArray(value)) {
      res = value.map(getTopTagListEl).join('')
    }
    el.innerHTML = res
  },
}
export const commonTagList = {
  inserted: (el, binding) => {
    const { badgeList, type } = binding.value
    let res = ''
    if (Array.isArray(badgeList)) {
      res = badgeList
        .map((tag, index) => {
          return type === 'brand'
            ? getBrandTagListEl(tag, index)
            : getBottomLabelListEl(tag)
        })
        .join('')
    }
    el.innerHTML = res
  },
}

export const ageTag = {
  update: (el, binding) => {
    const { value } = binding
    let res = ''
    if (Number(value) !== 0) {
      res = `<span class="tag-${value}">${value}</span>`
    }
    el.innerHTML = res
  },
}
const elementWatcherMap = {}
export const onDisplay = {
  inserted(el, binding) {
    const { value } = binding
    const onDisplay = _.get(value, ['sectionInfo', 'eventlist'], []).filter(
      (event) => {
        return event.type === 'on-display'
      },
    )
    const context = _.get(value, 'context', null)
    if (context !== null) {
      const elementWatcher = scrollMonitor.create(el, 50)
      elementWatcherMap[value.title] = elementWatcher
      elementWatcher.enterViewport(function () {
        context.$events.$emit(ON_DISPLAY_BAND, onDisplay[0])
      })
    }
  },
  unbind(el, binding) {
    const { value } = binding
    if (elementWatcherMap[value.title]) {
      elementWatcherMap[value.title] &&
        elementWatcherMap[value.title].destroy &&
        elementWatcherMap[value.title].destroy()
    }
  },
}

function getFilledSpan(innerText) {
  const span = document.createElement('span')
  span.innerText = innerText
  return span
}

function getSplitDot() {
  const dot = document.createElement('span')
  dot.classList.add('icon-dotted')
  return dot
}

function isValidString(string) {
  return string !== '' && string !== undefined && string !== null
}

function isValidNumber(number) {
  return isValidString(number) && number !== '0' && number !== 0
}

function vodTargetAge(targetage) {
  let innerText = ''
  let attribute = ''
  const age = Number(targetage)
  if (age === 0) {
    innerText = '전체'
    attribute = '전체 관람가'
  } else if (age === 21) {
    innerText = '청불'
    attribute = '청불'
  } else {
    innerText = `${targetage}세`
    attribute = `${targetage}세`
  }
  return { innerText, attribute }
}
function appendChildFn(el, fragment, list) {
  list.forEach((item, index) => {
    if (typeof item === 'object') {
      const span = document.createElement('span')
      span.setAttribute('innerText', item.attribute)
      span.innerText = item.innerText
      fragment.appendChild(span)
    } else {
      fragment.appendChild(getFilledSpan(item))
    }
    if (index < list.length - 1) fragment.appendChild(getSplitDot())
  })
  el.appendChild(fragment)
}
function vodInfoBoxFn(el, binding) {
  const info = _.get(binding, 'value.info', null)
  const type = _.get(binding, 'value.type', 'vod')
  if (info === null) return
  el.innerHTML = ''
  const fragment = document.createDocumentFragment()
  const {
    episodenumber,
    releasedate,
    releaseweekday,
    genretext,
    playtime,
    targetage,
  } = info
  let vodInfoList = []
  if (isValidNumber(episodenumber)) {
    vodInfoList.push(`${episodenumber}회`)
  }
  if (
    type === 'vod' &&
    isValidString(releasedate) &&
    isValidString(releaseweekday)
  ) {
    vodInfoList.push(`${releasedate} (${releaseweekday})`)
  }
  if (isValidString(genretext)) {
    vodInfoList.push(genretext)
  }
  if (isValidNumber(playtime)) {
    vodInfoList.push(`${Math.floor(playtime / 60)}분`)
  }
  if (isValidString(targetage)) {
    vodInfoList.push(vodTargetAge(targetage).innerText)
  }
  appendChildFn(el, fragment, vodInfoList)
}

export const vodInfoBox = {
  inserted(el, binding) {
    vodInfoBoxFn(el, binding)
  },
  update(el, binding) {
    vodInfoBoxFn(el, binding)
  },
}

function movieInfoBoxFn(el, binding) {
  const info = _.get(binding, 'value.info', null)
  if (info === null) return
  el.innerHTML = ''
  const fragment = document.createDocumentFragment()
  const { rating, genre, playtime, targetage } = info
  const genreText = _.get(genre, 'list.0.text', '')
  let movieInfoList = []
  if (isValidNumber(rating)) {
    movieInfoList.push(`평점 ${rating}`)
  }
  if (isValidString(genreText)) {
    movieInfoList.push(genreText)
  }
  if (isValidNumber(playtime)) {
    movieInfoList.push(`${Math.floor(playtime / 60)}분`)
  }
  if (isValidString(targetage)) {
    // MOVIE(영화) : 18세 이상을 청불로 표시
    // 0 / 12 / 15 / 18 / 21(19/19+)
    let innerText = ''
    let attribute = ''
    const age = Number(targetage)
    if (age === 0) {
      innerText = '전체'
      attribute = '전체 관람가'
    } else if (age < 20) {
      innerText = `${age}세`
      attribute = `${age}세 관람가`
    } else {
      innerText = '청불'
      attribute = '청불'
    }
    movieInfoList.push({ innerText: innerText, attribute: attribute })
  }
  appendChildFn(el, fragment, movieInfoList)
}
const PLAYER_DEFAULT_WIDTH = 1240
const PLAYER_DEFAULT_HEIGHT = 698
const PAYLOAD = 120

function getNewWidthHeight() {
  const CURRENT_HEIGHT_PX = window.innerHeight - PAYLOAD
  const CURRENT_WIDTH_PX = window.innerWidth - PAYLOAD

  const NEED_RESIZE =
    PLAYER_DEFAULT_WIDTH > CURRENT_WIDTH_PX ||
    PLAYER_DEFAULT_HEIGHT > CURRENT_HEIGHT_PX

  if (NEED_RESIZE) {
    const heightRatio = CURRENT_HEIGHT_PX / PLAYER_DEFAULT_HEIGHT
    const widthRatio = CURRENT_WIDTH_PX / PLAYER_DEFAULT_WIDTH
    const standardRatio = heightRatio > widthRatio ? widthRatio : heightRatio
    return {
      width: PLAYER_DEFAULT_WIDTH * standardRatio,
      height: PLAYER_DEFAULT_HEIGHT * standardRatio,
    }
  } else {
    return {
      width: PLAYER_DEFAULT_WIDTH,
      height: PLAYER_DEFAULT_HEIGHT,
    }
  }
}

function setPlayerWidthHeight(el, { width, height }) {
  const topContent = el.querySelector('.player-top-contents')
  const container = el.querySelector('#container')
  if (!topContent || !container) return
  topContent.style.height = `${height}px`
  container.style.width = `${width}px`
  container.style.height = `${height}px`
  const contentEl = document.querySelector('#contents')
  if (window.innerWidth >= 1240) {
    contentEl.setAttribute('style', 'min-width: 1240px')
  } else {
    contentEl.setAttribute('style', 'min-width: 300px')
  }
}
function resizeEventProcessor(el) {
  window.requestAnimationFrame(() => {
    setPlayerWidthHeight(el, getNewWidthHeight())
  })
}
let debouncedFn = null
function attachResizeEvent(el) {
  debouncedFn = _.debounce(function () {
    resizeEventProcessor(el)
  }, 350)
  window.addEventListener('resize', debouncedFn)
}
function removeResizeEvent() {
  window.removeEventListener('resize', debouncedFn)
  debouncedFn = null
}

export const adjustHeight = {
  inserted(el, binding) {
    resizeEventProcessor(el)
    attachResizeEvent(el)
  },
  unbind(el, binding) {
    removeResizeEvent()
  },
}

export const movieInfoBox = {
  inserted(el, binding) {
    movieInfoBoxFn(el, binding)
  },
  update(el, binding) {
    movieInfoBoxFn(el, binding)
  },
}
